import { getServerRuntimeConfig } from "./runtime-config";
export function getIdentityAppEnvironment() {
    var _a;
    const serverRuntimeConfig = getServerRuntimeConfig();
    const host = (_a = serverRuntimeConfig.DTN_IDENTITY_HOST) !== null && _a !== void 0 ? _a : "";
    let identityAppEnv = "prd";
    if (host.includes("gateway.dev.coreservices")) {
        identityAppEnv = "dev";
    }
    else if (host.includes("gateway.stg.coreservices")) {
        identityAppEnv = "stg";
    }
    return identityAppEnv;
}
export function buildIdentityUrl(path) {
    const identityAppEnv = getIdentityAppEnvironment();
    return `https://identity-proxy.${identityAppEnv}.coreservices.zones.dtn.com${path}`;
}
